import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiCheckAuthorizeStripe = (funcToDispatch, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/authorize_stripe",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({}),
    success: wrapSuccess(funcToDispatch),
    error: wrapError(error, "apiCheckAuthorizeStripe"),
  })
}

export const apiAdminDeleteUserDonation = (donationId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/personalDonationManager/${donationId}`,
    success,
    error: wrapError(error, "apiAdminDeleteUserDonation"),
  })
}

export const apiAdminEditUserDonation = (params, donationId, success, error) => {
  $.ajax({
    type: "PUT",
    url: `/api/admin/personalDonationManager/${donationId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "adminEditUserDonation"),
  })
}

export const apiAdminEditConstituentDonation = (
  params,
  constituentId,
  donationId,
  success,
  error,
) => {
  $.ajax({
    type: "PUT",
    url: `/api/admin/donationManager/${constituentId}/${donationId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "adminEditConstituentDonation"),
  })
}

export const apiAdminDeleteConstituentDonation = (constituentId, donationId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/donationManager/${constituentId}/${donationId}`,
    success,
    error: wrapError(error, "apiAdminDeleteConstituentDonation"),
  })
}

export const apiAdminAddUserDonation = (donationAmount, donationDate, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/personalDonationManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ donationAmount, donationDate }),
    success,
    error: wrapError(error, "apiAdminAddUserDonation"),
  })
}

export const apiAdminAddConstituentDonation = (
  constituentId,
  donationAmount,
  donationDate,
  success,
  error,
) => {
  $.ajax({
    type: "POST",
    url: `/api/admin/donationManager/${constituentId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ donationAmount, donationDate }),
    success,
    error: wrapError(error, "apiAdminAddConstituentDonation"),
  })
}
